import React from 'react'
import { useQuery } from 'react-query'
import { fetchMemberByID } from '../connections/requests'
import { Card, Container, createStyles, Divider, Flex, Group, Paper, Radio, Stack, Text, TextInput, Title } from '@mantine/core'
import { useLocation, useParams } from 'react-router-dom'
import { useForm } from '@mantine/form'




export default function RenewalForm() {
    const {membre} = useParams()
    const memberQuery = useQuery(["member",membre],fetchMemberByID)
    const form = useForm()
    console.dir(form.values)
    if(memberQuery.status ==="success" && !form.values.id) form.setValues({...memberQuery.data})
if(memberQuery.status==="success" && memberQuery.data)
        return (
            <>
            <Container p={"5%"}>
                <Card>
                    <Card.Section p={"lg"}>
                        <Stack>
                            <Title ta={"center"} underline order={3}>FICHE DE RENOUVELLEMENT D'ADHÉSION</Title>
                            <Title ta={"center"} order={4}>Du 1er avril 2025 au 31 mars 2026</Title>
                        </Stack>
                    </Card.Section>
                <Container m={"lg"} p={"xl"}>
                    <Text>Je désire renouveler mon adhésion à l’Association et je joins ma cotisation de 20,00 $, de la façon suivante :</Text>
                    <Radio.Group
                    px={"xl"}
                        withAsterisk
                        style={{lineHeight:0}}
                        >
                        <Stack>
                        <Flex  align={"center"}  gap={"sm"}>
                            <Radio my={0} py={0} value={"cash"}/>
                            <Text>Argent</Text>
                        </Flex>
                        <Flex  align={"center"}  gap={"sm"}>
                            <Radio value={"cheque"}/>
                            <Text align='center'>Chèque (à l’ordre : ADSMQ – MRC de L’Assomption et des Moulins)</Text>
                        </Flex>
                        <Flex  align={"center"}  gap={"sm"}>
                            <Radio value={"wire"}/>
                            <Text>Virement bancaire (à l’adresse courriel : coordination@adsmqam.org et la réponse de sécurité : ADSMQ)</Text>
                        </Flex>
                        <Flex  align={"center"} gap={"sm"}>
                            <Radio value={"online"}/>
                            <Text>Paiement en ligne : Cliquer sur « Devenir membre » sur notre site web https://www.adsmqam.org/ et vous pourrez renouveler votre adhésion.</Text>
                        </Flex>
                        </Stack>
                    </Radio.Group>
                    <Divider my={"xl"}/>
                    <Group>
                        <Text>J’inclus un don de charité au montant de</Text> <TextInput/> <Text>MERCI</Text>
                    </Group>
                    <Paper withBorder p={"xl"} m={"xl"}>
                        <Text fw={"bold"}>Veuillez noter qu’il n’est pas permis d’émettre des reçus pour fin d’impôt, en regard de la cotisation. Cependant, nous émettrons un reçu de charité pour un don de 10.00$ et +</Text>
                    </Paper>
                </Container>
                <Title underline ta={"center"} order={4}>Veuillez indiquer vos coordonnés dans l'espace suivant:</Title>
                <Text ta={"center"}>Vérifier si vous données sont exactes</Text>
                <Stack px={"8%"}>
                        <Group>
                            <Text>Nom et prénom :</Text>
                        <TextInput {...form.getInputProps("nom")}/>
                        <TextInput {...form.getInputProps("prenom")}/>
                        </Group>
                    <Group grow>
                        <TextInput label={"Adresse"} {...form.getInputProps("civic")}/>
                        <TextInput label={"Ville"} {...form.getInputProps("city")}/>
                    </Group>
                    <TextInput label={"Téléphone"} {...form.getInputProps("phone")}/>
                    <TextInput label={"Courriel"} {...form.getInputProps("email")}/>
                    <TextInput label={"Code postal"} {...form.getInputProps("postal")}/>
                    <Group>
                        <Text>Date de naissance :</Text>
                        <TextInput label={"Jour"} {...form.getInputProps("birthdate.day")}/>
                        <TextInput label={"Mois"} {...form.getInputProps("birthdate.month")}/>
                        <TextInput label={"Année"} {...form.getInputProps("birthdate.year")}/>
                    </Group>
                    <Radio.Group {...form.getInputProps("preferredComms")}>
                        <Text>Communication de l’informations </Text>
                        <Group>
                            <Radio value={"mail"}  />
                            <Text>Par courriel</Text>
                        </Group>
                        <Group>
                            <Radio value={"phone"}  />
                            <Text>Par téléphone</Text>
                        </Group>
                        <Group>
                            <Radio value={"postal"}  />
                            <Text>Par la poste</Text>
                        </Group>
                    </Radio.Group>
                </Stack>
                </Card>
            </Container>
            </>
        )
}
